module.exports = __webpack_public_path__ + "static/media/safety-toolbox-menu-item.e0d83f1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safety-toolbox-menu-item.svg
// module id = 176
// module chunks = 0